import React from 'react';

import Spinner from '../spinner';

import './style.scss';

const Loader = () => <Spinner />;

export default Loader;
